import moment from 'moment';

class AlertComment {
  constructor(
    alertId,
    id,
    text,
    timestamp,
    userId,
    firstName,
    lastName,
    type,
  ) {
    this.alertId = alertId;
    this.id = id;
    this.text = text;
    this.timestamp = timestamp;
    this.userId = userId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.type = type;
  }

  get commentedAtTimestamp() {
    const commentMoment = moment.unix(this.timestamp);
    const timeNow = moment();
    const timeSinceComment = moment.duration(timeNow.diff(commentMoment)).as('hours');
    return timeSinceComment > 24 ? moment.unix(this.timestamp).fromNow() : moment.unix(this.timestamp).format('h:mm A');
  }
}
export default AlertComment;
